/**
 * Per-claim coverage helpers for V4 backend suggestions.
 */

/**
 * @param {Object} suggestion
 * @param {string|number} claimId
 * @returns {number|null} coverage in [0, 1] or null when not linked
 */
export function getCoverageForClaim(suggestion, claimId) {
    if (!suggestion || claimId == null) return null;
    const idStr = String(claimId);

    const coverage = suggestion.claimCoverage;
    if (Array.isArray(coverage)) {
        const row = coverage.find((c) => String(c.claimId) === idStr);
        if (row?.coverage != null && !Number.isNaN(Number(row.coverage))) {
            return Number(row.coverage);
        }
    }

    const ids = suggestion.forClaimIds || [];
    if (Array.isArray(ids) && ids.map(String).includes(idStr)) {
        if (suggestion.proofLevel != null && !Number.isNaN(Number(suggestion.proofLevel))) {
            return Number(suggestion.proofLevel);
        }
        if (suggestion.score != null && !Number.isNaN(Number(suggestion.score))) {
            return Number(suggestion.score);
        }
    }

    return null;
}

/**
 * @param {Object} suggestion
 * @returns {{ claimId: string|number, coverage: number }[]}
 */
export function listClaimCoverage(suggestion) {
    if (!suggestion) return [];
    if (Array.isArray(suggestion.claimCoverage) && suggestion.claimCoverage.length > 0) {
        return suggestion.claimCoverage
            .filter((row) => row?.coverage != null)
            .map((row) => ({
                claimId: row.claimId,
                coverage: Number(row.coverage),
            }));
    }
    const ids = suggestion.forClaimIds || [];
    const fallback = suggestion.proofLevel ?? suggestion.score ?? null;
    if (fallback == null) return [];
    return ids.map((claimId) => ({claimId, coverage: Number(fallback)}));
}
